type ToastVariant = 'error' | 'success' | 'info'

export interface ToastPayload {
  id: string
  message: string
  title?: string
  variant: ToastVariant
}

type ToastInput = Omit<ToastPayload, 'id'>
type ToastListener = (payload: ToastPayload) => void

const listeners = new Set<ToastListener>()

function createToastId() {
  return `${Date.now()}-${Math.random().toString(16).slice(2, 8)}`
}

export function subscribeToast(listener: ToastListener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function pushToast(input: ToastInput) {
  const payload: ToastPayload = {
    id: createToastId(),
    ...input,
  }

  for (const listener of listeners) {
    listener(payload)
  }
}

export function pushErrorToast(message: string, title = '操作失败') {
  const content = message.trim()
  if (!content) {
    return
  }

  pushToast({
    title,
    message: content,
    variant: 'error',
  })
}

export function pushSuccessToast(message: string, title = '操作成功') {
  const content = message.trim()
  if (!content) {
    return
  }

  pushToast({
    title,
    message: content,
    variant: 'success',
  })
}
